/* eslint-disable */

import { useState, useEffect, useRef } from "react";

// react-router components
import { Link } from "react-router-dom";

import { Link as ScrollLink } from "react-scroll";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";

// Soft UI Dashboard PRO React example components
import DefaultNavbarLink from "examples/Navbars/DefaultNavbar/DefaultNavbarLink";
import DefaultNavbarMobile from "examples/Navbars/DefaultNavbar/DefaultNavbarMobile";

// Soft UI Dashboard PRO React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Custom styles for DashboardNavbar
import styles from "../DefaultNavbar/styles/defaultNavbar";

// DefaultNavbar dropdown menus
import PagesMenu from "examples/Navbars/DefaultNavbar/Menus/PagesMenu";
import AuthenticationMenu from "examples/Navbars/DefaultNavbar/Menus/AuthenticationMenu";
import EcommerceMenu from "examples/Navbars/DefaultNavbar/Menus/EcommerceMenu";
import ApplicationsMenu from "examples/Navbars/DefaultNavbar/Menus/ApplicationsMenu";
import DocsMenu from "examples/Navbars/DefaultNavbar/Menus/DocsMenu";
import { sendEvent } from "ga4";

function DefaultNavbar({ routes, transparent, light, action }) {
  const scollToRef = useRef();
  const classes = styles({ light });
  const [pagesMenu, setPagesMenu] = useState(false);
  const [authenticationMenu, setAuthenticationMenu] = useState(false);
  const [ecommerceMenu, setEcommerceMenu] = useState(false);
  const [applicationsMenu, setApplicationsMenu] = useState(false);
  const [docsMenu, setDocsMenu] = useState(false);
  const [mobileNavbar, setMobileNavbar] = useState(false);
  const [mobileView, setMobileView] = useState(false);

  const openPagesMenu = ({ currentTarget }) => setPagesMenu(currentTarget);
  const closePagesMenu = () => setPagesMenu(false);
  const closeAuthenticationMenu = () => setAuthenticationMenu(false);
  const openEcommerceMenu = ({ currentTarget }) => setEcommerceMenu(currentTarget);
  const closeEcommerceMenu = () => setEcommerceMenu(false);
  const openApplicationsMenu = ({ currentTarget }) => setApplicationsMenu(currentTarget);
  const closeApplicationsMenu = () => setApplicationsMenu(false);
  const closeDocsMenu = () => setDocsMenu(false);
  const openMobileNavbar = ({ currentTarget }) => setMobileNavbar(currentTarget.parentNode);
  const closeMobileNavbar = () => setMobileNavbar(false);

  useEffect(() => {
    // A function that sets the display state for the DefaultNavbarMobile.
    function displayMobileNavbar() {
      if (window.innerWidth < breakpoints.values.lg) {
        setMobileView(true);
        setMobileNavbar(false);
      } else {
        setMobileView(false);
        setMobileNavbar(false);
      }
    }

    /** 
     The event listener that's calling the displayMobileNavbar function when 
     resizing the window.
    */
    window.addEventListener("resize", displayMobileNavbar);

    // Call the displayMobileNavbar function to set the state with the initial value.
    displayMobileNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", displayMobileNavbar);
  }, []);

  return (
    <Container>
      <SuiBox
        customClass={mobileView ? classes.mobileNavbar : classes.defaultNavbar}
        py={1}
        px={{ xs: transparent ? 4 : 5, sm: transparent ? 2 : 5, lg: transparent ? 0 : 5 }}
      >
        <SuiBox
          display={{ xs: "inline-block", lg: "inline-block" }}
          component={Link}
          to="/"
          py={transparent ? 1.5 : 0.75}
          lineHeight={1}
          onClick={() => sendEvent("Home click")}
        >
          <SuiTypography fontWeight="bold" textColor={light ? "white" : "dark"}>
            Home
          </SuiTypography>
        </SuiBox>
        <SuiBox
          display={{ xs: "none", lg: "inline-block" }}
          component={ScrollLink}
          to="why"
          py={transparent ? 1.5 : 0.75}
          lineHeight={1}
          customClass="cursor-pointer h-100 object-cover"
          onClick={() => sendEvent("Why click")}
        >
          <SuiTypography fontWeight="bold" textColor={light ? "white" : "dark"}>
            Why
          </SuiTypography>
        </SuiBox>

        <SuiBox
          display={{ xs: "none", lg: "inline-block" }}
          component={ScrollLink}
          to="features"
          py={transparent ? 1.5 : 0.75}
          lineHeight={1}
          customClass="cursor-pointer h-100 object-cover"
          onClick={() => sendEvent("Features click")}
        >
          <SuiTypography fontWeight="bold" textColor={light ? "white" : "dark"}>
            Features
          </SuiTypography>
        </SuiBox>

        <SuiBox
          display={{ xs: "none", lg: "inline-block" }}
          component={ScrollLink}
          to="about"
          py={transparent ? 1.5 : 0.75}
          lineHeight={1}
          customClass="cursor-pointer h-100 object-cover"
          onClick={() => sendEvent("About click")}
        >
          <SuiTypography fontWeight="bold" textColor={light ? "white" : "dark"}>
            About
          </SuiTypography>
        </SuiBox>

        <SuiBox
          display={{ xs: "none", lg: "inline-block" }}
          component={ScrollLink}
          to="contact"
          py={transparent ? 1.5 : 0.75}
          lineHeight={1}
          customClass="cursor-pointer h-100 object-cover"
          onClick={() => sendEvent("Contact click")}
        >
          <SuiTypography fontWeight="bold" textColor={light ? "white" : "dark"}>
            Contact
          </SuiTypography>
        </SuiBox>
        {action &&
          (action.type === "internal" ? (
            <SuiBox display={{ xs: "inline-block", lg: "inline-block" }}>
              <SuiButton
                component={Link}
                to={action.route}
                variant="gradient"
                buttonColor={action.color ? action.color : "info"}
                size="small"
                circular
              >
                {action.label}
              </SuiButton>
            </SuiBox>
          ) : (
            <SuiBox display={{ xs: "none", lg: "inline-block" }}>
              <SuiButton
                component="a"
                href={action.route}
                target="_blank"
                rel="noreferrer"
                variant="gradient"
                buttonColor={action.color ? action.color : "info"}
                size="small"
                circular
              >
                {action.label}
              </SuiButton>
            </SuiBox>
          ))}

        {/*  {mobileView && (
          <DefaultNavbarMobile routes={routes} open={mobileNavbar} close={closeMobileNavbar}>
            Hello
          </DefaultNavbarMobile>
        )} */}

        {/* <SuiBox
          display={{ xs: "inline-block", lg: "none" }}
          lineHeight={0}
          py={1.5}
          pl={1.5}
          color="inherit"
          customClass="cursor-pointer"
          onClick={openMobileNavbar}
        >
          <Icon className="" fontSize="default">
            {mobileNavbar ? "close" : "menu"}
          </Icon>
        </SuiBox> */}
      </SuiBox>
      {/* <PagesMenu routes={routes} open={pagesMenu} close={closePagesMenu} />
      <AuthenticationMenu
        routes={routes}
        open={authenticationMenu}
        close={closeAuthenticationMenu}
      />
      <EcommerceMenu routes={routes} open={ecommerceMenu} close={closeEcommerceMenu} />
      <ApplicationsMenu routes={routes} open={applicationsMenu} close={closeApplicationsMenu} />
      <DocsMenu routes={routes} open={docsMenu} close={closeDocsMenu} />
      {mobileView && (
        <DefaultNavbarMobile routes={routes} open={mobileNavbar} close={closeMobileNavbar}>
          Hello
        </DefaultNavbarMobile>
      )} */}
    </Container>
  );
}

// Setting default values for the props of DefaultNavbar
DefaultNavbar.defaultProps = {
  transparent: false,
  light: false,
  action: false,
};

// Typechecking props for the DefaultNavbar
DefaultNavbar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  transparent: PropTypes.bool,
  light: PropTypes.bool,
  action: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      type: PropTypes.oneOf(["external", "internal"]).isRequired,
      route: PropTypes.string.isRequired,
      color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
        "light",
        "white",
      ]),
      label: PropTypes.string.isRequired,
    }),
  ]),
};

export default DefaultNavbar;
